module.exports = __webpack_public_path__ + "img/home_tab_sel_icon@2x.1cac16a5.png";